import Breakpoints from '@polestar/component-warehouse-react/tokens/breakpoints/Breakpoints';
export const createMediaQuery = (minWidth, type = 'media', maxWidth = undefined) => `@${type} (min-width: ${minWidth}px)${maxWidth !== undefined ? ` and (max-width: ${maxWidth}px)` : ''}`;
const MediaQueries = Object.freeze({
    mobile: createMediaQuery(Breakpoints.mobile),
    tablet: createMediaQuery(Breakpoints.tablet),
    desktop: createMediaQuery(Breakpoints.desktop),
    desktopWide: createMediaQuery(Breakpoints.desktopWide),
    /**
     * This is only needed for edge-cases (like where on tablet a different style is needed) while default CSS mediaquery stacking is preferred.
     */
    onlyMobile: createMediaQuery(Breakpoints.mobile, 'media', Breakpoints.tablet - 1),
    /**
     * This is only needed for edge-cases (like where on tablet a different style is needed) while default CSS mediaquery stacking is preferred.
     */
    onlyTablet: createMediaQuery(Breakpoints.tablet, 'media', Breakpoints.desktop - 1),
    /**
     * This is only needed for edge-cases (like where on tablet a different style is needed) while default CSS mediaquery stacking is preferred.
     */
    onlyDesktop: createMediaQuery(Breakpoints.tablet, 'desktop', Breakpoints.desktopWide - 1),
    /**
     * This is only needed for edge-cases (like where on tablet a different style is needed) while default CSS mediaquery stacking is preferred.
     */
    untilDesktop: createMediaQuery(Breakpoints.mobile, 'media', Breakpoints.desktop - 1),
});
export default MediaQueries;
